var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClone = function SvgClone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clone_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 21.724a.5.5 0 0 1-.9.022L1.407 7.583a.5.5 0 0 1 .679-.671l14.589 7.751-5 2.5Z",
    className: "clone_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.676 8.163-.3-.6a.5.5 0 0 1 .681-.663l13.762 7.311a.5.5 0 0 1-.011.889l-4.133 2.066-2.5 5.5-2-4",
    className: "clone_svg__a"
  })));
};
export default SvgClone;